var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadphoneJack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 34,
    viewBox: "0 0 130 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.293213,
    y: 7.74683,
    width: 17.5789,
    height: 18.5555,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8722 7.74687C17.8722 3.97132 20.9329 0.910645 24.7084 0.910645L76.4684 0.910645V33.1386L24.7084 33.1386C20.9329 33.1386 17.8722 30.0779 17.8722 26.3024V7.74687Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4216,
    y: 6.77026,
    width: 2.92981,
    height: 21.4853,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 111.626,
    y: 8.72339,
    width: 2.92981,
    height: 17.5789,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 81.3516,
    y: 9.7002,
    width: 7.81283,
    height: 15.6257,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 91.1176,
    y: 9.7002,
    width: 8.78944,
    height: 15.6257,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.86,
    y: 9.69995,
    width: 8.78944,
    height: 15.6257,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.392 10.798C120.499 11.007 119.009 11.4146 117.443 11.8051C114.744 12.4781 112.603 14.9063 112.603 17.688C112.603 20.8057 115.285 23.6653 118.334 24.3176C119.374 24.5399 120.423 24.7702 121.392 24.9588C124.81 25.6236 129.205 23.0055 129.205 18.1225C129.205 13.2395 124.81 9.99794 121.392 10.798Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphoneJack);
export default __webpack_public_path__ + "static/media/headphone-jack.996b5d44fc67b5235f523362e83bf9c5.svg";
export { ForwardRef as ReactComponent };